export const environment = {
    production: false,
    api_url: 'https://taskflow-qa.matthewrkilleen.com/api',
    environment_name: 'qa'
};
